import React from "react";
import { Navbar } from "..";
import "./about.css";
import Icon1 from "../../assets/Icon-1.svg";
import Icon2 from "../../assets/Icon-2.svg";
import Icon3 from "../../assets/Icon-3.svg";
import Icon4 from "../../assets/Icon-4.svg";
import Icon5 from "../../assets/Icon-5.svg";
import Icon6 from "../../assets/Icon-6.svg";
import Icon7 from "../../assets/Icon-7.svg";
import Icon8 from "../../assets/Icon-8.svg";
import { Roadmap } from "../Roadmap/Roadmap";

const Masternoding = () => {
  return (
    <div className="masternoding">
      <div className="masternoding__explain">
        <div className="mn__explain_heading_container">
          <h1>MASTERNODING</h1>
        </div>
        <div className="mn__explain_para_container">
          <p>
            An interesting way to earn revenue by providing technology is by
            providing a Masternode that runs on a proof-of-stake (PoS) base.
            <br />
            In addition to the advantages of the blockchain as a technology, it
            is possible to achieve interesting yields by providing computing
            power and storage space in combination with special software.
          </p>
        </div>
      </div>
      <div className="masternoding__explain">
        <div className="mn__explain_heading_container">
          <h1>HOW IT WORKS?</h1>
        </div>
        <div className="mn__explain_para_container">
          <p>
            A master node, like any other full node, is a node server within a
            network, and full nodes are important because they process
            transactions and store them in the blockchain.
            <br />
            However, a master node operator has rights and tasks more than those
            of a normal full node operator, and is required to manage more
            critical tasks which bring the operator higher rewards.
            <br />
            In order to obtain the status of a Masternode, the master node
            operator must deposit a required number of the corresponding coins.
            For this “staking”, along with performance of the specific tasks and
            the provision of computing power with storage space, the operator
            receives rewards based on the corresponding coins (proof-of-stake).
            <br />
            By operating appropriate masternode of a coin diligently whilst
            constantly monitoring the surrounding of the coin and optimizing
            masternodes with clever strategies, extraordinary profits can be
            made.
          </p>
        </div>
      </div>
      <div className="masternoding__explain">
        <div className="mn__explain_heading_container">
          <h1>MANAGED RISKS</h1>
        </div>
        <div className="mn__explain_para_container">
          <p>
            - Masternoding is NOT trading, so loss of capital is very low or
            negligible. Demension operates masternodes of low MCap worthy
            cryptos with future potential growth and great background community.
            <br />
            - Naturally, there are expenses, uncertain costs of server etc. But
            servers are rented and contracts can be cancelled. Users are
            basically renting servers, they don't have to pay server costs.
            <br />
            - Fluctuations in coin prices affect the market, and master node
            earnings are always in coins, but server team monitor the master
            nodes constantly and are able to react quickly to any events that
            might impact the yield.
            <br />- Since the staked tokens becomes free again when a masternode
            is switched off, Dimension can pay back deposits at any time.
          </p>
        </div>
      </div>
    </div>
  );
};

const About = () => {
  return (
    <div>
      <div className="about" id="about">
        <div className="about__heading">
          <h1>About</h1>
          <h2>What is Dimension?</h2>
        </div>
        <div className="about__divs_container">
          <div className="about__div_containers">
            <div className="about__img_container">
              <img src={Icon4} />
            </div>
            <div className="about__text_container">
              <p>
                Dimension is a proof-of-stake masternode mining protocol which
                enables staking mechanism that is a one click investment
                platform, where users will be able to stake their tokens to get
                a high yield interest of around 80% to 100% per annum.
              </p>
            </div>
          </div>
          <div className="about__div_containers">
            <div className="about__img_container">
              <img src={Icon2} />
            </div>
            <div className="about__text_container">
              <p>
                Dimension Protocol help other proof-of-stake cryptocurrencys by
                increasing their efficiency in validation process which help
                them increase their transaction speed and limits.
              </p>
            </div>
          </div>
          <div className="about__div_containers">
            <div className="about__img_container">
              <img src={Icon3} />
            </div>
            <div className="about__text_container">
              <p>
                Dimension Protocol is a complex masternode mining program which
                is a blockchain based economy. This protocol generates revenue
                by operating several masternodes, price gains and services
                provided leveraging each cryptocurrency's blockchain.
              </p>
            </div>
          </div>
        </div>
        <div className="invest__container">
          <button className="about__invest">Invest Now</button>
        </div>
      </div>
      <Masternoding />
      <Roadmap />
    </div>
  );
};

export default About;
